<template>
    <div>
        <Toolbar>
            <BackButton :href="$route('order.details', [store.id, order.url_key])" :to="order.integration_order_id"/>
        </Toolbar>

        <Card>
            <template v-slot:icon>
                <i class="fas fa-box font-size-h2 mr-1"/>
            </template>
            <template v-slot:title>
                Create package for order {{ order.integration_order_id }}
            </template>
            <template v-slot:description>
                Create a package containing all or a part of the ordered items.
            </template>

            <OrderPackageForm v-if="unpackedItems.length > 0" :order="order" :presets="packagePresets"
                              v-model="package"/>
            <div>
                <Alert v-if="unpackedItems.length === 0" title="All items have been prepared." type="light-info">
                    <template v-slot:icon>
                        <i class="fas fa-exclamation-circle" />
                    </template>

                    There are no more items to pack.

                    <div class="mt-3">
                        <Link as="button" class="btn btn-sm btn-outline-info" :href="$route('order.details', {storeUuid: store.id, orderCode: order.url_key, tab: 'packages'})">
                            Return to order
                        </Link>
                    </div>
                </Alert>
            </div>

            <template v-slot:footer>
                <button v-if="unpackedItems.length > 0" class="btn btn-primary" :disabled="!canFinalizePackage"
                        @click="createPackage">
                    <i class="fas fa-check-square"/>
                    Create package and notify driver/customer
                </button>
            </template>
        </Card>
    </div>
</template>

<script>
import OrderPackageForm from "@components/Orders/OrderPackageForm.vue";
import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import Alert from "@components/Alert.vue";
import { Link } from '@inertiajs/vue2';

export default {
    components: {Alert, BackButton, Toolbar, Card, OrderPackageForm, Link},

    props: {
        order: Object,
        store: Object,
        packagePresets: Array
    },

    data() {
        return {
            defaultDimensions: {
                length: {
                    unit: 'cm',
                    value: 0
                },
                width: {
                    unit: 'cm',
                    value: 0
                },
                height: {
                    unit: 'cm',
                    value: 0
                },
            },
            package: this.$inertia.form({
                dimensions: this.defaultDimensions,
                weight: {
                    unit: 'gr',
                    value: 0
                },
                hazmat: '',
                package_contents: []
            })
        }
    },

    methods: {
        createPackage() {
            this.package.put(this.$route('order.packages.create', [this.store.id, this.order.url_key]))
        }
    },

    computed: {
        unpackedItems() {
            let out = [];
            for (let item of this.order.items) {
                if (item.quantity_unpacked > 0) {
                    out.push(item);
                }
            }
            return out;
        },

        canFinalizePackage() {
            return this.package.weight.value > 0
        }
    }
}
</script>
